// framework
import React, { useState, useCallback, useMemo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { audio } from "services/audioManager";
import { sleep } from "utils/sleep";

// styles
import styles from "./StartMenu.module.scss";

// components
import Button from "components/Shared/Button/Button";

// constants
import { IMAGES, MESSAGES } from "constants/constants";
import { GAME_STATES } from "constants/constants";
import { MUSIC, VO } from "constants/audio";

const START_BUTTON_TIMEOUT_MS = 3000;
const START_HINT_VO_DELAY = 2000;

async function runStartMenuSequence({ signal }) {
    if (signal.aborted) return;
    audio.playMusic(MUSIC.GAME_INTO_LOOP, { loop: true, fadeMs: 5000, signal });
    await sleep(START_HINT_VO_DELAY)
    audio.playVo(VO.DONT_KNOW_HOW_TO_PLAY, { signal });
}
export default function StartMenuView({ gameState, room, players, sendIfPrimary, isMirror }) {
    const [isStarting, setIsStarting] = useState(false);

    const isActive = gameState === GAME_STATES.START_MENU;

    const connected = useMemo(() => (players ?? []).filter((p) => p?.connected), [players]);
    const canStart = connected.length >= 1;

    const handleStartClicked = useCallback(() => {
        if (!sendIfPrimary || !canStart) return;
        sendIfPrimary(MESSAGES.TO_SERVER.PLAYER_START_GAME, {});
        setIsStarting(true);

        setTimeout(() => {
            setIsStarting(false);
        }, START_BUTTON_TIMEOUT_MS);
    }, [sendIfPrimary, canStart]);

    // Audio sequence
    useEffect(() => {
        if (!isActive) return;
        const ac = new AbortController();
        runStartMenuSequence({ signal: ac.signal })
        return () => {
            ac?.abort();
        };
    }, [isActive]);

    return (
        <section className={styles.startMenuView} data-show={isActive ? "true" : "false"} data-testid="start-menu-view">

            <img src={IMAGES.HOST.introBackground} alt="" aria-hidden="true" className={styles.background} />

            <div className={styles.buttons} data-show={canStart ? "true" : "false"}>
                <Button onClick={handleStartClicked} disabled={!canStart || isStarting || isMirror} className={styles.startButton} style={isMirror ? { opacity: 0.5 } : {}} >
                    {isStarting ? "Starting..." : "Start Game"}
                </Button>
            </div>
        </section>
    );
}

StartMenuView.propTypes = {
    gameState: PropTypes.any,
    room: PropTypes.object,
    players: PropTypes.array,
};